import React from "react";
import { SimpleShowLayout, TextField, BooleanField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="baseball.id" />
      <TextField source="baseball.homeRuns" />
      <TextField source="baseball.doubles" />
      <TextField source="baseball.triples" />
      <BooleanField source="baseball.isPitcher" />
    </SimpleShowLayout>
  );
};

export default Tab;
